import { State } from './reducer';
import { PayloadAction } from '@reduxjs/toolkit';

export const setViewportWidth = (
	state: State,
	action: PayloadAction<number>
) => {
	state.viewportWidth = action.payload;
};
